import { render, staticRenderFns } from "./sysAlarm.vue?vue&type=template&id=b88b9e46&scoped=true&"
import script from "./sysAlarm.vue?vue&type=script&lang=js&"
export * from "./sysAlarm.vue?vue&type=script&lang=js&"
import style0 from "./sysAlarm.vue?vue&type=style&index=0&id=b88b9e46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88b9e46",
  null
  
)

export default component.exports